import { CommonModule, DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatListModule } from '@angular/material/list';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { TranslocoModule } from '@jsverse/transloco';
import { BackendService } from 'src/app/services/backend.service';
import type { ApiResponses } from 'src/app/services/backend.service';
import type { components } from 'src/app/shared/types/api.type';

type ChangelogList = ApiResponses['changelogSnapshot/listSnapshots'];
type ChangelogSnapshot = components['schemas']['ChangelogSnapshotResponseDto'];
type ChangelogItem = components['schemas']['ChangelogSnapshotItemDto'];

@Component({
  selector: 'app-changelog-dialog',
  templateUrl: './changelog-dialog.component.html',
  imports: [
    CommonModule,
    TranslocoModule,
    MatDialogModule,
    MatButtonModule,
    MatExpansionModule,
    MatListModule,
    MatProgressBarModule,
    DatePipe
  ],
  styleUrl: './changelog-dialog.component.scss'
})
export class ChangelogDialogComponent implements OnInit {
  loading = true;
  loadError = false;
  data: ChangelogList | null = null;

  constructor(
    public dialogRef: MatDialogRef<ChangelogDialogComponent>,
    private readonly backendService: BackendService
  ) {}

  ngOnInit(): void {
    this.backendService
      .get<'changelogSnapshot/listSnapshots'>('support/changelog', {
        query: { limit: 100, offset: 0 }
      })
      .subscribe({
        next: (body) => {
          this.data = body;
          this.loading = false;
        },
        error: () => {
          this.loadError = true;
          this.loading = false;
        }
      });
  }

  trackSnapshot(_i: number, s: ChangelogSnapshot): number {
    return s.changelogSnapshotId;
  }

  trackItem(_i: number, it: ChangelogItem): string {
    return it.jiraKey;
  }
}
